/**
 * Supabase custom domains and the project each one fronts. supabase-js names
 * the session cookie after the URL's first hostname label, so a custom domain
 * must map back to its project ref or every user is signed out when
 * NEXT_PUBLIC_SUPABASE_URL moves to it. Add a domain here before switching.
 */
const CUSTOM_DOMAIN_PROJECT_REFS: Record<string, string> = {
  'api.asksa.app': 'vbuxgpwooywqyerjawij',
};

/** The project ref behind a Supabase URL (`<ref>.supabase.co` or a custom domain). */
export function getSupabaseProjectRef(url: string) {
  const { hostname } = new URL(url);

  return (
    CUSTOM_DOMAIN_PROJECT_REFS[hostname] ?? hostname.split('.')[0] ?? hostname
  );
}

/** The session cookie name, stable across a move to a custom domain. */
export function getSupabaseAuthCookieName(url: string) {
  return `sb-${getSupabaseProjectRef(url)}-auth-token`;
}

/**
 * The project's own `https://<ref>.supabase.co` origin when the URL is one of
 * our custom domains: rows written before the move still point at it.
 */
export function getSupabaseProjectOrigin(url: string) {
  const { hostname } = new URL(url);
  const ref = CUSTOM_DOMAIN_PROJECT_REFS[hostname];

  return ref ? `https://${ref}.supabase.co` : null;
}
